import {prepareUpsellData} from '@optimaxdev/analytics/desktop/lib/ecommerce/helpers/index';
import {createEECUpsellEvent} from '@optimaxdev/analytics/desktop/lib/ecommerce/typ/index';
import {pushDataLayer} from '@optimaxdev/analytics/desktop/lib/pushDataLayer/index';

import {logWithSentryEEC} from 'libs/sentry/sentry';

import {UpsellType} from '../../types/upsellsTypes';

/**
 * prepares impressions and sends event EEC_TYP_Upgrades_Impressions to DataLayer
 * @param {UpsellType[]} upsells - array of viewed upsells; used in field "impressions" of event
 * @param {Function} getUpsellPosition - function should return position of upsell from rendered list
 * @param {'Upgrades' | 'Accessories'} eventType - used for generating field "event" of event
 */
export const sendAnalytics = (
    upsells: UpsellType[],
    getUpsellPosition: (upsell: UpsellType) => number,
    eventType: 'Upgrades' | 'Accessories',
) => {
    const impressions = upsells.map(upsell => ({
        ...prepareUpsellData(upsell),
        dimension74: getUpsellPosition(upsell),
    }));
    const event = createEECUpsellEvent({eventType, impressions});
    pushDataLayer(event);
    logWithSentryEEC(`EEC_TYP_${eventType}_Impressions`, event);
};
